"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
const core_1 = require("@angular/core");
const moment_1 = __importDefault(require("moment"));
const abstract_analysis_component_1 = __importDefault(require("../abstract/abstract-analysis.component"));
const vehicle_1 = require("../../shared/models/vehicle/vehicle");
const enums_1 = require("../../@shared-types/vehicle/enums");
const users_service_1 = require("../../../../shared/users/users.service");
var HandoverChartData;
(function (HandoverChartData) {
    HandoverChartData["MAKE"] = "make";
    HandoverChartData["MODEL"] = "model";
    HandoverChartData["SELLER"] = "seller";
})(HandoverChartData || (HandoverChartData = {}));
var HandoverTableData;
(function (HandoverTableData) {
    HandoverTableData["CUSTOMER"] = "customerId";
    HandoverTableData["VIN"] = "vin";
    HandoverTableData["PLANNED_HANDOVER"] = "plannedHandover";
    HandoverTableData["VEHICLE_ID"] = "vehicleId";
})(HandoverTableData || (HandoverTableData = {}));
let HandoverAnalysisComponent = class HandoverAnalysisComponent extends abstract_analysis_component_1.default {
    constructor(vehicle, usersService) {
        super();
        this.vehicle = vehicle;
        this.usersService = usersService;
        this.getData = () => __awaiter(this, void 0, void 0, function* () {
            const vehicles = yield this.vehicle.getAll({
                $and: [
                    { 'vehicleData.availability.code': enums_1.EAvailabilityCode.Sold },
                    { 'vehicleData.inventory.state': enums_1.EInventoryState.Stock },
                ],
            });
            const tableData = [];
            const chartData = [];
            vehicles.forEach((v) => {
                var _a, _b, _c, _d;
                if (!v.vehicleData.availability.sellData)
                    return;
                const seller = this.usersService.getNameOfUser(v.vehicleData.availability.sellData.seller || 0, '(Ohne Verkäufer)');
                tableData.push({
                    vehicleId: String(v._id),
                    customerId: v.vehicleData.availability.sellData.customerId,
                    date: v.vehicleData.availability.sellData.contractDate,
                    make: ((_a = v.modelData) === null || _a === void 0 ? void 0 : _a.make) || '(Ohne Modell)',
                    model: ((_b = v.modelData) === null || _b === void 0 ? void 0 : _b.model) || '(Ohne Modell)',
                    seller,
                    vin: v.vin,
                    plannedHandover: !v.vehicleData.availability.sellData.plannedHandover ? '(Nicht angegeben)' : (0, moment_1.default)(v.vehicleData.availability.sellData.plannedHandover).format('DD.MM.YYYY'),
                });
                chartData.push({
                    date: v.vehicleData.availability.sellData.contractDate,
                    make: ((_c = v.modelData) === null || _c === void 0 ? void 0 : _c.make) || '(Ohne Modell)',
                    model: ((_d = v.modelData) === null || _d === void 0 ? void 0 : _d.model) || '(Ohne Modell)',
                    seller,
                });
            });
            return { chart: chartData, table: tableData };
        });
        this.chartTitle = 'Ausstehende Auslieferungen';
        this.mode = 'SUM';
        this.filter = {
            filterGroup: HandoverChartData.MAKE,
            filterOptions: {
                make: [],
                model: [],
                seller: [],
            },
            filterTranslations: {
                make: 'Marke',
                model: 'Modell',
                seller: 'Verkäufer',
            },
            filterValues: {
                make: [],
                model: [],
                seller: [],
            },
            yearOptions: [],
            yearValue: (0, moment_1.default)().format('YYYY'),
        };
    }
};
HandoverAnalysisComponent = __decorate([
    (0, core_1.Component)({
        selector: 'handover-analysis',
        templateUrl: require('./handover-analysis.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof vehicle_1.Vehicle !== "undefined" && vehicle_1.Vehicle) === "function" ? _a : Object, typeof (_b = typeof users_service_1.UsersService !== "undefined" && users_service_1.UsersService) === "function" ? _b : Object])
], HandoverAnalysisComponent);
exports.default = HandoverAnalysisComponent;
